import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Button from "../../Button";
import { FOCUSABLE_ELEMENTS_SELECTOR } from "../../../constants";

const TableMenu = ({ active, className, children, ...restProps }) => {
  const [open, setOpen] = useState(active);
  const buttonRef = useRef(null);
  const popupRef = useRef(null);

  const keyDownHandler = useCallback(({ code }) => {
    if (code === "Escape") {
      setOpen(false);
      buttonRef.current.focus();
    }
  }, []);

  const clickHandler = useCallback(({ target }) => {
    if (buttonRef.current !== target) setOpen(false);
  }, []);

  useEffect(() => {
    if (open) {
      const [firstFocusable] = popupRef.current.querySelectorAll(
        FOCUSABLE_ELEMENTS_SELECTOR
      );
      if (firstFocusable) firstFocusable.focus();
      document.addEventListener("keydown", keyDownHandler);
      document.addEventListener("click", clickHandler);
    }

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
      document.removeEventListener("click", clickHandler);
    };
  }, [keyDownHandler, clickHandler, open]);

  return (
    <div className={classnames("table-menu", className)}>
      <Button
        ref={buttonRef}
        className="table-menu__button"
        variant="link"
        iconName="system-dot-menu-vertical"
        size="small"
        aria-haspopup={true}
        aria-expanded={open}
        onClick={(e) => {
          e?.stopPropagation();
          setOpen(!open);
        }}
        {...restProps}
      >
        View Actions
      </Button>
      {open && (
        <div className="table-menu__popup" ref={popupRef}>
          {children}
        </div>
      )}
    </div>
  );
};

TableMenu.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

TableMenu.defaultProps = {
  active: false,
};

export default TableMenu;
